export default "__VITE_ASSET__BSs3gyxU__"